/* Gota Clara — interacciones (vanilla, sin librerías) */
(function () {
  if (window.__gcInit) return;
  window.__gcInit = true;

  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var io = null;

  function once(el) {
    if (el.dataset.gcInit) return false;
    el.dataset.gcInit = '1';
    return true;
  }

  function initReveals(root) {
    var els = (root || document).querySelectorAll('.gc-reveal, .gc-pasos, .gc-tabla');
    if (reduce || !('IntersectionObserver' in window)) {
      els.forEach(function (el) { el.classList.add('gc-visible'); });
      return;
    }
    if (!io) {
      io = new IntersectionObserver(function (entries) {
        entries.forEach(function (e) {
          if (e.isIntersecting) { e.target.classList.add('gc-visible'); io.unobserve(e.target); }
        });
      }, { threshold: 0.15, rootMargin: '0px 0px -40px 0px' });
    }
    els.forEach(function (el) { if (!el.classList.contains('gc-visible')) io.observe(el); });
  }

  /* Hotspots: punto <-> tarjeta */
  function initHotspots(root) {
    (root || document).querySelectorAll('[data-gc-hotspots]').forEach(function (wrap) {
      if (!once(wrap)) return;
      var puntos = wrap.querySelectorAll('[data-gc-punto]');
      var items = wrap.querySelectorAll('[data-gc-item]');
      function activar(i) {
        puntos.forEach(function (p) { p.classList.toggle('is-activo', p.dataset.gcPunto === i); });
        items.forEach(function (it) { it.classList.toggle('is-activo', it.dataset.gcItem === i); it.setAttribute('aria-pressed', it.dataset.gcItem === i ? 'true' : 'false'); });
      }
      puntos.forEach(function (p) {
        p.addEventListener('click', function () { activar(p.dataset.gcPunto); });
        p.addEventListener('mouseenter', function () { activar(p.dataset.gcPunto); });
      });
      items.forEach(function (it) {
        it.addEventListener('click', function () { activar(it.dataset.gcItem); });
        it.addEventListener('mouseenter', function () { activar(it.dataset.gcItem); });
      });
      if (puntos[0]) activar(puntos[0].dataset.gcPunto);
    });
  }

  /* Comparador antes/después */
  function initComparador(root) {
    (root || document).querySelectorAll('[data-gc-comp]').forEach(function (comp) {
      if (!once(comp)) return;
      var boton = comp.querySelector('.gc-ad-boton');
      var pos = parseFloat(comp.dataset.inicio || '50');
      function set(p) { pos = Math.max(2, Math.min(98, p)); comp.style.setProperty('--gc-pos', pos + '%'); if (boton) boton.setAttribute('aria-valuenow', Math.round(pos)); }
      function desde(ev) { var r = comp.getBoundingClientRect(); var x = (ev.touches ? ev.touches[0].clientX : ev.clientX) - r.left; set(x / r.width * 100); }
      var arrastrando = false;
      comp.addEventListener('pointerdown', function (e) { arrastrando = true; desde(e); comp.setPointerCapture && comp.setPointerCapture(e.pointerId); });
      comp.addEventListener('pointermove', function (e) { if (arrastrando) desde(e); });
      ['pointerup', 'pointercancel', 'pointerleave'].forEach(function (t) { comp.addEventListener(t, function () { arrastrando = false; }); });
      if (boton) boton.addEventListener('keydown', function (e) {
        if (e.key === 'ArrowLeft') { set(pos - 5); e.preventDefault(); }
        if (e.key === 'ArrowRight') { set(pos + 5); e.preventDefault(); }
      });
      set(pos);
    });
  }

  /* FAQ */
  function initFaq(root) {
    (root || document).querySelectorAll('[data-gc-faq]').forEach(function (lista) {
      if (!once(lista)) return;
      lista.querySelectorAll('.gc-faq-item').forEach(function (item) {
        var q = item.querySelector('.gc-faq-q');
        q.addEventListener('click', function () {
          var abierto = item.classList.toggle('is-abierto');
          q.setAttribute('aria-expanded', abierto ? 'true' : 'false');
        });
      });
    });
  }

  /* CTA magnético */
  function initMagnetico(root) {
    if (reduce || !window.matchMedia('(hover: hover)').matches) return;
    (root || document).querySelectorAll('[data-gc-magnetico]').forEach(function (btn) {
      if (!once(btn)) return;
      btn.addEventListener('mousemove', function (e) {
        var r = btn.getBoundingClientRect();
        var dx = (e.clientX - r.left - r.width / 2) / r.width;
        var dy = (e.clientY - r.top - r.height / 2) / r.height;
        btn.style.transform = 'translate(' + (dx * 8).toFixed(1) + 'px,' + (dy * 6).toFixed(1) + 'px)';
      });
      btn.addEventListener('mouseleave', function () { btn.style.transform = ''; });
    });
  }

  /* Parallax suave del CTA */
  function initParallax(root) {
    if (reduce) return;
    var els = (root || document).querySelectorAll('[data-gc-parallax]');
    if (!els.length) return;
    function tick() {
      els.forEach(function (el) {
        var r = el.parentElement.getBoundingClientRect();
        if (r.bottom < 0 || r.top > window.innerHeight) return;
        var p = (r.top + r.height / 2 - window.innerHeight / 2) / window.innerHeight;
        el.style.transform = 'translateY(' + (p * -40).toFixed(1) + 'px)';
      });
    }
    window.addEventListener('scroll', function () { window.requestAnimationFrame(tick); }, { passive: true });
    tick();
  }

  /* Página de producto: galería + variantes + cantidad + barra fija */
  function formatoDinero(cents, formato) {
    var v = (cents / 100).toFixed(2);
    var conComa = v.replace('.', ',');
    var f = formato || '{{amount}}';
    return f.replace(/\{\{\s*amount_with_comma_separator\s*\}\}/, conComa)
      .replace(/\{\{\s*amount_no_decimals\s*\}\}/, Math.round(cents / 100))
      .replace(/\{\{\s*amount\s*\}\}/, v);
  }

  function initProducto(root) {
    (root || document).querySelectorAll('[data-gc-producto]').forEach(function (wrap) {
      if (!once(wrap)) return;
      var datosEl = wrap.querySelector('[data-gc-variantes]');
      var variantes = datosEl ? JSON.parse(datosEl.textContent) : [];
      var formato = wrap.dataset.formato;
      var main = wrap.querySelector('[data-gc-main]');
      var thumbs = Array.prototype.slice.call(wrap.querySelectorAll('[data-gc-thumb]'));
      var idx = 0;

      function verFoto(i) {
        if (!thumbs.length || !main) return;
        idx = (i + thumbs.length) % thumbs.length;
        var t = thumbs[idx];
        main.src = t.dataset.grande;
        main.alt = t.dataset.alt || '';
        thumbs.forEach(function (x, j) { x.classList.toggle('is-activo', j === idx); });
        t.scrollIntoView && t.scrollIntoView({ block: 'nearest', inline: 'nearest' });
      }
      thumbs.forEach(function (t, i) { t.addEventListener('click', function () { verFoto(i); }); });
      var prev = wrap.querySelector('[data-gc-prev]');
      var next = wrap.querySelector('[data-gc-next]');
      if (prev) prev.addEventListener('click', function () { verFoto(idx - 1); });
      if (next) next.addEventListener('click', function () { verFoto(idx + 1); });

      var inputId = wrap.querySelector('input[name="id"]');
      var precioEl = wrap.querySelector('[data-gc-precio]');
      var tachadoEl = wrap.querySelector('[data-gc-tachado]');
      var botones = wrap.querySelectorAll('[data-gc-add]');
      var stickyPrecio = document.querySelector('[data-gc-sticky-precio]');
      var textoAdd = wrap.dataset.textoAdd;
      var textoAgotado = wrap.dataset.textoAgotado;

      function seleccion() {
        var opts = [];
        wrap.querySelectorAll('[data-gc-opcion]').forEach(function (fs) {
          var c = fs.querySelector('input:checked');
          opts.push(c ? c.value : null);
          var lbl = fs.querySelector('[data-gc-opcion-valor]');
          if (lbl && c) lbl.textContent = c.value;
        });
        return opts;
      }
      function actualizar() {
        var opts = seleccion();
        var v = variantes.find(function (x) { return x.options.every(function (o, i) { return o === opts[i]; }); });
        if (!v) {
          botones.forEach(function (b) { b.disabled = true; b.querySelector('span').textContent = textoAgotado; });
          return;
        }
        if (inputId) inputId.value = v.id;
        if (precioEl) precioEl.textContent = formatoDinero(v.price, formato);
        if (stickyPrecio) stickyPrecio.textContent = formatoDinero(v.price, formato);
        if (tachadoEl) {
          if (v.compare_at_price && v.compare_at_price > v.price) { tachadoEl.textContent = formatoDinero(v.compare_at_price, formato); tachadoEl.hidden = false; }
          else tachadoEl.hidden = true;
        }
        botones.forEach(function (b) { b.disabled = !v.available; b.querySelector('span').textContent = v.available ? textoAdd : textoAgotado; });
        if (v.featured_media_id) {
          var i = thumbs.findIndex(function (t) { return t.dataset.mediaId === String(v.featured_media_id); });
          if (i > -1) verFoto(i);
        }
        if (window.history && window.history.replaceState && wrap.dataset.url) {
          window.history.replaceState({}, '', wrap.dataset.url + '?variant=' + v.id);
        }
      }
      wrap.querySelectorAll('[data-gc-opcion] input').forEach(function (inp) { inp.addEventListener('change', actualizar); });

      var cant = wrap.querySelector('[data-gc-cantidad]');
      if (cant) {
        var inpC = cant.querySelector('input');
        cant.querySelectorAll('button').forEach(function (b) {
          b.addEventListener('click', function () {
            var n = parseInt(inpC.value || '1', 10) + parseInt(b.dataset.paso, 10);
            inpC.value = Math.max(1, n);
          });
        });
      }

      var sticky = document.querySelector('[data-gc-sticky]');
      var form = wrap.querySelector('form[action*="/cart/add"]');
      if (sticky && form && 'IntersectionObserver' in window) {
        var obs = new IntersectionObserver(function (es) {
          es.forEach(function (e) { sticky.classList.toggle('is-visible', !e.isIntersecting && e.boundingClientRect.top < 0); });
        });
        obs.observe(form);
        var sb = sticky.querySelector('button');
        if (sb) sb.addEventListener('click', function () { var b = form.querySelector('[data-gc-add]'); if (b && !b.disabled) b.click(); });
      }
    });
  }


  /* Carrusel de opiniones */
  function initCarrusel(root) {
    (root || document).querySelectorAll("[data-gc-carrusel]").forEach(function (wrap) {
      if (!once(wrap)) return;
      var pista = wrap.querySelector("[data-gc-pista]");
      if (!pista) return;
      function paso() { var c = pista.querySelector(".gc-rs-card"); return c ? c.getBoundingClientRect().width + 20 : pista.clientWidth; }
      function mover(dir) {
        var max = pista.scrollWidth - pista.clientWidth - 4;
        if (dir > 0 && pista.scrollLeft >= max) pista.scrollTo({ left: 0 });
        else if (dir < 0 && pista.scrollLeft <= 4) pista.scrollTo({ left: max });
        else pista.scrollBy({ left: dir * paso() });
      }
      var p = wrap.querySelector("[data-gc-rs-prev]"), n = wrap.querySelector("[data-gc-rs-next]");
      if (p) p.addEventListener("click", function () { mover(-1); });
      if (n) n.addEventListener("click", function () { mover(1); });
      if (wrap.dataset.autoplay === "true" && !reduce) {
        var t = null, ms = (parseInt(wrap.dataset.intervalo, 10) || 5) * 1000;
        var start = function () { stop(); t = setInterval(function () { mover(1); }, ms); };
        var stop = function () { if (t) clearInterval(t); t = null; };
        wrap.addEventListener("mouseenter", stop); wrap.addEventListener("mouseleave", start);
        pista.addEventListener("touchstart", stop, { passive: true }); pista.addEventListener("focusin", stop);
        start();
      }
    });
  }

  function initTodo(e) {
    var root = e && e.target && e.target.querySelectorAll ? e.target : document;
    initReveals(root);
    initHotspots(root);
    initComparador(root);
    initFaq(root);
    initMagnetico(root);
    initProducto(root);
    initCarrusel(root);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { initTodo(); initParallax(); });
  else { initTodo(); initParallax(); }
  document.addEventListener('shopify:section:load', initTodo);
})();
